import { createContext, useContext } from 'react'
import type { SipPlansOverviewResponse } from '../api/overview.types'
import { SipActionFilter, SipPlanMode } from '../api/types'
import type { DerivedSipPlansView } from './deriveSipPlansView'
import type { SipPlanCategoryExpansionState } from './usePlanCategoryBucketExpansion'

export type SipPlansQueryState = {
  isLoading: boolean
  isError: boolean
  isFetching: boolean
  refetch: () => void
}

export type SipPlansContextValue = {
  planMode: SipPlanMode
  handlePlanModeChange: (planMode: SipPlanMode) => void
  actionFilter: SipActionFilter
  actionFiltersByPlanMode: Record<SipPlanMode, SipActionFilter>
  handleActionFilterChange: (filter: SipActionFilter) => void
  plansOverview: SipPlansOverviewResponse | undefined
  derivedPlans: DerivedSipPlansView | undefined
  plansQuery: SipPlansQueryState
  submitIdealSipAmount: (totalIdealSipAmount: number) => void
  /** Mark that strategy timer resume refetch ran (for leave). */
  markTimerResumeRefetch: () => void
  leavePlansList: () => void
} & SipPlanCategoryExpansionState

export const SipPlansContext = createContext<SipPlansContextValue | null>(null)

export function useSipPlansContext(): SipPlansContextValue {
  const contextValue = useContext(SipPlansContext)
  if (!contextValue) {
    throw new Error('useSipPlansContext must be used within SipPlansProvider')
  }
  return contextValue
}
